import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { CardDataprop } from "./types";

export const CardContainer = (props: CardDataprop) => {
  const { t } = useTranslation();
  const translate = t as unknown as (key: string) => string;
  const pathname = useLocation().pathname === "/" ? true : false;

  return (
    <div
      className={`bp:row-4 bp:px-[10px] pb-[14px] grid grid-cols-2 gap-4 ${
        pathname ? "" : "flex-wrap"
      } `}
    >
      {props.cardData.map((card, index) => (
        <a key={index} href={`/products/${props.url}/${card.name}`}>
          <div className="col-1">
            <div
              className="relative bp:w-[194px] h-[164px] rounded-lg bg-cover bg-center"
              style={{ backgroundImage: `url(${card.image_url})` }}
            >
              {card.discount > 0 && (
                <span className="absolute top-2 right-1 rounded-2xl px-2 py-[2px] bg-main-dark border border-white satoshi-xs-bold-discount text-center">
                  {card.discount}% off
                </span>
              )}
            </div>
            <span className="py-1 px-2 satoshi-sm-medium-main-light dark:text-white">
              {translate(card.name)}
            </span>
          </div>
        </a>
      ))}
    </div>
  );
};
